<template>
  <div>
    <b-row class="m-0">
      <b-col sm="12" class="p-0">
        <div class="card bg-light mb-3">
          <div class="card-header bg-dark text-white">
              <h6 class="mb-0"><font-awesome-icon icon="edit" /> Update Record</h6>
          </div>
          <div class="card-body p-2"  v-if="typeof leave_application.manpower != 'undefined'">
            <b-row align-v="center" class="loader" v-if="is_saving">
              <b-col>
                <b-spinner></b-spinner>
                <br><br>
                <strong>Loading</strong>
              </b-col>
            </b-row>
            <b-alert show :variant="leave_application.alert_class" >This application is <strong>{{leave_application.status_description}}</strong></b-alert>
            <b-row class="bg-white m-0 border">
              <b-col class=" p-3">
                  <b-row class="m-0 mb-3">
                    <b-col cols="1" class="text-center p-2 bg-info text-white d-flex align-items-center justify-content-center">
                      <font-awesome-icon icon="user" class="h2 mb-0" />
                    </b-col>
                    <b-col class="p-2 bg-white d-flex align-items-center border">
                      <div>
                        <h6 class="mb-0 text-muted">Employee</h6>
                        <h2 class="mb-0">
                          <a href="#">
                            <template><strong>{{leave_application.manpower.full_name}}</strong> <b-badge variant="info">{{leave_application.manpower.employee_id}}</b-badge></template>
                          </a>
                        </h2>
                      </div>
                    </b-col>
                  </b-row>
                  <table class="table table-bordered mb-0 table-sm">
                    <thead class="thead-dark">
                    <tr>
                      <th scope="col">Leave Description</th>
                      <th scope="col" class="text-center">Qty</th>
                      <th scope="col" class="text-center">Date</th>
                      <th scope="col" class="text-center">Remarks</th>
                    </tr>
                    </thead>
                    <tbody class="bg-white text-dark">
                    <tr>
                      <td>
                        <strong>{{leave_application.leave_benefit.description}}</strong>
                      </td>
                      <td class="text-center">
                        {{leave_application.qty}}
                      </td>
                      <td class="text-center">
                        {{leave_application.date.other_formats.format_1}}
                      </td>
                      <td class="text-center">
                        {{leave_application.remarks}}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                    <fieldset class="border p-3 my-3">
                      <legend  class="w-auto bg-facebook px-2 py-1 text-white rounded border h6">Action Remarks</legend>

                      <b-form-textarea
                              id="textarea"
                              v-model="form.action_remarks"
                              placeholder="..."
                              rows="3"
                              max-rows="6"
                              required
                              v-if="leave_application.status==0"
                      ></b-form-textarea>
                      <template v-else>
                        {{leave_application.action_remarks}}
                      </template>
                    </fieldset>
                  <div class="text-right">
                    <router-link to="/manpowers/leave-applications/all">
                      <b-button variant="dark" size="sm" class="mr-1">
                        <font-awesome-icon icon="chevron-left" /> Back</b-button>
                    </router-link>
                    <b-button-group size="sm" v-if="leave_application.status==0">
                      <b-button variant="danger" @click="decline()">Decline</b-button>
                      <b-button  type="submit" variant="success" @click="approve()">Approve</b-button>
                    </b-button-group>
                  </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>

  import SwalMixin from '@/views/mixins/Swal.js'
    export default {
      components: {},
      mixins:[SwalMixin],
      data() {
        return {
          leave_application:{},
          form:{
            id:-1,
            action_remarks:''
          }
        }
      },
      created(){
        this.form.id = this.$route.params.id;
        this.get();
      },
      methods: {
        get(){
          this.is_saving=true;
          this.axios.get('leave-applications/get',{params:{id:this.$route.params.id}}).then(response => {
            this.leave_application = response.data;
            this.is_saving=false;
          }).catch(error => console.log(error));
        },
        decline(){
          event.preventDefault();
          if(this.form.action_remarks==''){
            this.swal_transaction_error_data.text = 'Please put a remarks for you action.';
            this.swalRequestError();
            return;
          }
          this.swalConfirmSubmit((data)=>{
            if (data.value) {
              this.is_saving=true;
              this.axios.post('leave-applications/decline',this.form).then(response => {
                this.swalTransactionCompleted();
                this.is_saving=false;
                this.get();
              }).catch(error => {
                this.swal_transaction_error_data.text = error.response.data;
                this.swalRequestError();
                this.is_saving=false;
              });
            }
          });
        },
        approve(){
          event.preventDefault();
          if(this.form.action_remarks==''){
            this.swal_transaction_error_data.text = 'Please put a remarks for you action.';
            this.swalRequestError();
            return;
          }
          this.swalConfirmSubmit((data)=>{
            if (data.value) {
              this.is_saving=true;
              this.axios.post('leave-applications/approve',this.form).then(response => {
                this.swalTransactionCompleted();
                this.is_saving=false;
                this.get();
              }).catch(error => {
                this.swal_transaction_error_data.text = error.response.data;
                this.swalRequestError();
                this.is_saving=false;
              });
            }
          });
        },
      }
    }
</script>
